import { combineReducers } from "redux";
import authReducer from "./reducers/auth/auth.reducer";
import usersReducer from "./reducers/users/users.reducer";
import schoolsReducer from "./reducers/schools/schools.reducer";
import plantelsReducer from "./reducers/plantels/plantels.reducer";
import usersFormReducer from "./reducers/users/usersForm.slice";
import talentosReducer from "./reducers/talentos/talentos.reducer";
import frasesReducer from "./reducers/frases/frases.reducer";
import phraseBuilderReducer from "./reducers/phraseBuilder/phraseBuilder.slice";
import phraseBuilderPlantelReducer from "./reducers/phraseBuilderPlantel/phraseBuilderPlantel.slice";
import frasesRespuestaReducer from "./reducers/frasesRespuesta/frasesRespuesta.reducer";
import talentsByPlantels from "./reducers/plantels/talentsByPlantels.reducer";
import frasesByPlantelReducer from "./reducers/plantels/phrasesByPlantel.reducer";
import talentsSelector from "./reducers/plantels/talentsSelector.reducer";
import responsePhrasesReducer from "./reducers/plantels/responsePhrases.reducer";
import quizReducer from "./quiz/quiz.slice";
import mejoresTalentosReducer from "./reducers/dashboard/mejoresTalentos/mejoresTalentos.reducer";
import menosTalentosReducer from "./reducers/dashboard/menosTalentos/menosTalentos.reducer";
import distribucionTalentosReducer from "./reducers/dashboard/distribucionTalentos/distribucionTalentos.reducer";
import dominanciaTalentosReducer from "./reducers/dashboard/dominanciaTalentos/dominanciaTalentos.reducer";
import dashboardFiltersReducer from "./reducers/dashboard/dashboardFilters/dashboardFilters.slice";
import resultadosEvaluacionReducer from "./reducers/dashboard/resultadosEvaluacion/resultadosEvaluacion.reducer";
import preguntasConfirmacionReducer from "./reducers/preguntasConfirmacion/preguntasConfirmacion.reducer";
import frasesConfirmacionReducer from "./reducers/frasesConfirmacion/frasesConfirmacion.reducer";
import preguntasConfirmacionPlantelReducer from "./reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.reducer";
import frasesConfirmacionPlantelRecuer from "./reducers/frasesConfirmacion/Frasesconfirmacionplantel.reducer"
import confirmacionReducer from "./confirmacion/confirmacion.slice";

const rootReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  usersForm: usersFormReducer,
  schools: schoolsReducer,
  plantels: plantelsReducer,
  talentos: talentosReducer,
  frases: frasesReducer,
  phraseBuilder: phraseBuilderReducer,
  phraseBuilderPlantel: phraseBuilderPlantelReducer,
  frasesRespuesta: frasesRespuestaReducer,
  talentosByPlantels: talentsByPlantels,
  frasesByPlantel: frasesByPlantelReducer,
  talentsSelector: talentsSelector,
  responsePhrases: responsePhrasesReducer,
  quiz: quizReducer,
  mejoresTalentos: mejoresTalentosReducer,
  menosTalentos: menosTalentosReducer,
  distribucionTalentos: distribucionTalentosReducer,
  dominanciaTalentos: dominanciaTalentosReducer,
  dashboardFilters: dashboardFiltersReducer,
  resultadosEvaluacion: resultadosEvaluacionReducer,
  preguntasConfirmacion: preguntasConfirmacionReducer,
  frasesConfirmacion: frasesConfirmacionReducer,
  preguntasConfirmacionPlantel: preguntasConfirmacionPlantelReducer,
  frasesConfirmacionPlantel: frasesConfirmacionPlantelRecuer,
  confirmacion: confirmacionReducer,
});

export default rootReducer;
